import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { FormField } from "cxa-form-field";
import { useDispatch } from "react-redux";
import DeleteIcon from "../../assets/images/icon/delete.svg";
import { removeReceipt } from "../../actions/claimActionsPP";
import PDFViewer from "./PDFViewer";
import ZoomInIconNew from "../../assets/images/icon/zoom_in.svg";
import ZoomOutIconNew from "../../assets/images/icon/zoom_out.svg";
import PinchInIcon from "../../assets/images/icon/pinch-in-icon.svg";
import PinchOutIcon from "../../assets/images/icon/pinch-out-icon.svg";
import PinchInIconDisabled from "../../assets/images/icon/pinch-in-icon-disabled.svg";
import PinchOutIconDisabled from "../../assets/images/icon/pinch-out-icon-disabled.svg";
import { TransformWrapper, TransformComponent, useControls } from "react-zoom-pan-pinch";

const Controls = ({ scale }) => {
  const { zoomIn, zoomOut } = useControls();
  return (
    <div>
      <div className="icon-container desktop-view">
        <ZoomInIconNew
          onClick={scale < 4 ? () => zoomIn() : undefined}
          style={{ marginBottom: 10, cursor: "pointer" }}
          className={scale < 4 ? "vector-icons-icon-color" : undefined}
        />
        <ZoomOutIconNew
          onClick={scale > 1 ? () => zoomOut() : undefined}
          style={{ marginBottom: 10, cursor: "pointer" }}
          className={scale > 1 ? "vector-icons-icon-color" : undefined}
        />
      </div>
      <div className="icon-container mobile-view">
        {scale >= 4 ? (
          <PinchInIconDisabled style={{ marginBottom: 10, cursor: "auto" }} />
        ) : (
          <PinchInIcon onClick={() => zoomIn()} style={{ marginBottom: 10, cursor: "pointer" }} />
        )}
        {scale === 1 ? (
          <PinchOutIconDisabled style={{ marginBottom: 10, cursor: "auto" }} />
        ) : (
          <PinchOutIcon onClick={() => zoomOut()} style={{ marginBottom: 10, cursor: "pointer" }} />
        )}
      </div>
    </div>
  );
};

export const ReceiptPreviewer = ({
  value,
  onChange,
  ocrValues,
  allowDelete = true,
  match: { params },
}) => {
  const dispatch = useDispatch();
  const deleteFile = file => {
    onChange(value.filter(item => item !== file));
    dispatch(removeReceipt(file.objectId, params.selectedDelegator));
  };

  const [currentScale, setCurrentScale] = useState(1);

  function handleTransform(e) {
    setCurrentScale(e.instance.transformState.scale);
  }

  return (
    <Fragment>
      {value.length > 0 && (
        <div className="receipt-preview-container">
          {allowDelete && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                cursor: "pointer",
              }}
            >
              <DeleteIcon
                onClick={() => {
                  deleteFile(value[0]);
                }}
                className="vector-icons-icon-color"
              />
            </div>
          )}
          <div className="receipt-image-container">
            {!ocrValues && value[0].contentType == "application/pdf" ? (
              <TransformWrapper maxScale={4} onTransformed={e => handleTransform(e)}>
                <TransformComponent>
                  <PDFViewer pdfUrl={value[0].fileUrl} />
                </TransformComponent>
                <Controls scale={currentScale} />
              </TransformWrapper>
            ) : (
              <TransformWrapper maxScale={4} onTransformed={e => handleTransform(e)}>
                <TransformComponent>
                  <img
                    src={
                      (ocrValues && ocrValues.ocrFile && ocrValues.ocrFile.fileUrl) ||
                      value[0].fileUrl
                    }
                    alt="Receipt"
                  />
                </TransformComponent>
                <Controls scale={currentScale} />
              </TransformWrapper>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

Controls.propTypes = {
  scale: PropTypes.number.isRequired,
};

ReceiptPreviewer.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.array,
  ocrValues: PropTypes.object,
  allowDelete: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      selectedDelegator: PropTypes.string,
    }),
  }),
};

const ReceiptFieldPP = props => (
  <FormField multiple={true} component={ReceiptPreviewer} {...props} />
);

export default ReceiptFieldPP;



// WEBPACK FOOTER //
// ./components/claim/ReceiptPreviewField.js